"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SolendLpDepositAction = void 0;
const bignumber_js_1 = require("bignumber.js");
const sdk_1 = require("@malloc-protocol/sdk");
const web3_js_1 = require("@solana/web3.js");
const anchor_1 = require("@malloc-protocol/anchor");
const solend = __importStar(require("@solendprotocol/common"));
const { getTokenAccountUsedByMalloc } = sdk_1.utils.tokens;
const dbricks_solend_1 = require("@dbricks/dbricks-solend");
const spl_token_lending_1 = require("@solana/spl-token-lending");
const cpi_action_json_1 = __importDefault(require("../../target/idl/cpi_action.json"));
const common_1 = require("@project-serum/common");
const cpi_action_1 = require("../utils/cpi-action");
const actionTypeUID = "MALLOC_SPL_SOLEND_LP_DEPOSIT";
const INITIAL_COLLATERAL_RATIO_WAD = new bignumber_js_1.BigNumber("1000000000000000000");
const getSolendConfig = (config) => {
    if (config === "devnet")
        return solend.devnetConfig;
    else if (config === "testnet")
        throw `Solend has not testnet configs`;
    else if (config === "mainnet-beta")
        return solend.productionConfig;
    else
        throw `Unexpected config of ${config}`;
};
// TODO: this only supports devnet right now
// https://github.com/Lev-Stambler/malloc-solana2/issues/8
const buildIsolatedSolend = ({ inp, inputTokens: inputTokenAccounts, actionPID, provider, authority, config, opts, }) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    if (inputTokenAccounts.length !== 1)
        `Solend depositing expects 1 input mint`;
    const mintIn = inputTokenAccounts[0].mint;
    const tokenAccountIn = inputTokenAccounts[0].tokenAccount;
    const solendConfig = getSolendConfig(config.cluster);
    const assetSymbol = (_a = solendConfig.assets.find((asset) => asset.mintAddress === mintIn.toBase58())) === null || _a === void 0 ? void 0 : _a.symbol;
    if (!assetSymbol) {
        throw `Looks like solend does not support token of mint ${mintIn.toBase58()}`;
    }
    const mainMarket = solendConfig.markets[0];
    const reserve = mainMarket.reserves.find((r) => r.asset === assetSymbol);
    if (!reserve) {
        throw `Looks like Solend does not have a market for ${assetSymbol}`;
    }
    const collateralMint = new web3_js_1.PublicKey(reserve.collateralMintAddress);
    const destinationCollateralAccount = yield getTokenAccountUsedByMalloc(provider.wallet.publicKey, collateralMint, opts === null || opts === void 0 ? void 0 : opts.preferredTokenAccounts);
    const oracle = solendConfig.oracles.assets.find((o) => o.asset === assetSymbol);
    if (!oracle)
        throw `Could not find the oracle for ${assetSymbol}`;
    const { data: refreshData } = (0, spl_token_lending_1.refreshReserveInstruction)(new web3_js_1.PublicKey(reserve.address), new web3_js_1.PublicKey(oracle.priceAddress));
    const depositInst = (0, dbricks_solend_1.depositReserveLiquidityInstruction)(0, tokenAccountIn, destinationCollateralAccount, new web3_js_1.PublicKey(reserve.address), new web3_js_1.PublicKey(reserve.liquidityAddress), collateralMint, new web3_js_1.PublicKey(mainMarket.address), new web3_js_1.PublicKey(mainMarket.authorityAddress), authority, new web3_js_1.PublicKey(solendConfig.programID));
    const estimateOutsPartial = (amounts) => __awaiter(void 0, void 0, void 0, function* () {
        const out = yield estimateReserveOut(reserve, provider.connection, new anchor_1.BN(amounts[0].amount), mintIn);
        return [{ amount: out, mint: collateralMint }];
    });
    return {
        estimateOuts: estimateOutsPartial,
        isolatedAction: {
            tokenMintIn: mintIn,
            actionData: (0, cpi_action_1.packInstrData)(depositInst.data, cpi_action_1.InstructionType.SOLEND_LIQUIDITY_DEPOSIT),
            actionProgram: new web3_js_1.PublicKey(actionPID),
            actionAccounts: [
                { address: mintIn },
                { address: depositInst.programId },
                ...sdk_1.utils.object.actionMetasToAccountsArray(depositInst.keys),
            ],
            opts: {
                instructions: [
                    new web3_js_1.TransactionInstruction({
                        data: refreshData,
                        programId: new web3_js_1.PublicKey(solendConfig.programID),
                        keys: [
                            {
                                pubkey: new web3_js_1.PublicKey(reserve.address),
                                isWritable: true,
                                isSigner: false,
                            },
                            {
                                pubkey: new web3_js_1.PublicKey(oracle.priceAddress),
                                isWritable: false,
                                isSigner: false,
                            },
                            {
                                pubkey: new web3_js_1.PublicKey(oracle.switchboardFeedAddress),
                                isWritable: false,
                                isSigner: false,
                            },
                            {
                                pubkey: web3_js_1.SYSVAR_CLOCK_PUBKEY,
                                isSigner: false,
                                isWritable: false,
                            },
                        ],
                    }),
                ],
            },
            additionalSigners: [],
            tokenMintOuts: [collateralMint],
            tokenAccountOuts: [destinationCollateralAccount],
        },
    };
});
const estimateReserveOut = (reserve, connection, liquidityIn, mint) => __awaiter(void 0, void 0, void 0, function* () {
    const mintInfo = yield sdk_1.utils.tokens.getMintInfo(connection, mint);
    const divideInputBy = mintInfo.decimals > 6 ? Math.pow(10, mintInfo.decimals - 6) : 1;
    // Solend expects to work in tokens denominated by 10^-6. So a token like WSOL must
    // be divided by 10^3 because it is denominated in 10^-9 shares
    const liquidityInFormatted = liquidityIn.divn(divideInputBy);
    const liquidityAccount = new web3_js_1.PublicKey(reserve.liquidityAddress);
    const reserveAddr = new web3_js_1.PublicKey(reserve.address);
    const reserveParsed = (0, dbricks_solend_1.parseReserve)(reserveAddr, yield connection.getAccountInfo(reserveAddr));
    const exchangeRate = getExchangeRate(reserveParsed.data);
    const tokAccount = (0, common_1.parseTokenAccount)((yield connection.getAccountInfo(liquidityAccount)).data);
    const liquidityInBigNum = new bignumber_js_1.BigNumber(liquidityInFormatted.toString());
    const out = liquidityInBigNum
        .times(exchangeRate)
        .integerValue(bignumber_js_1.BigNumber.ROUND_DOWN)
        .toString();
    return new anchor_1.BN(out);
});
// TODO: get exchange rate to work
const getExchangeRate = (reserve) => {
    const totalLiquidity = reserve.liquidity.borrowedAmountWads.plus(new bignumber_js_1.BigNumber(reserve.liquidity.availableAmount.toString()));
    const mintTotalSupp = new bignumber_js_1.BigNumber(reserve.collateral.mintTotalSupply.toString());
    // TODO: is this 5 or 1??????
    if (totalLiquidity.eq(0) || mintTotalSupp.eq(0)) {
        return INITIAL_COLLATERAL_RATIO_WAD;
    }
    else {
        return mintTotalSupp.div(totalLiquidity);
    }
};
exports.SolendLpDepositAction = {
    buildIsolatedAction: buildIsolatedSolend,
    actionTypeUID,
    expectedNumberOutMints: 1,
    idl: cpi_action_json_1.default,
};
